<template>
  <div class="home">
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <div class="brand-hero">
      <div class="brand-hero-content">
        <h1>{{h1s[h1target]}}</h1>
        <hr class="short">
        <div class="row">
          <div class="col-12 col-md-10 col-lg-4 mx-auto">
            <p>Sekvoia is Warsaw based company with deeply developed passion for JavaScript based solutions.</p>
            <button type="button" class="btn btn-outline-light">Learn More</button>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <h2 class="title">Services</h2>
        <div class="row">
          <div class="col-md-6 col-lg-3">
            <div class="service">
              <div class="icon">
                <i class="fal fa-expand fa-2x"></i>
              </div>
              <h5>Web Development</h5>
              <p>Literally any Web Application development, usually based on well known JavaScript goodies such as Angular and Vue.js.</p>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="service">
              <div class="icon">
                <i class="fal fa-paint-brush fa-2x"></i>
              </div>
              <h5>Web Design</h5>
              <p>Proffesional web oriented design service, operated by experienced team with strong UI/UX background.</p>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="service">
              <div class="icon">
                <i class="fal fa-mobile fa-2x"></i>
              </div>
              <h5>Mobile Development</h5>
              <p>JavaScript based mobile solutions. Progressive Web Apps and hybrid mobile applications development (Angular/Vue + Web View).</p>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="service">
              <div class="icon">
                <i class="fal fa-cut fa-2x"></i>
              </div>
              <h5>Design to HTML</h5>
              <p>Professional conversion of Sketch, Adobe Photoshop based designs to HTML5, CSS3 compilant code, usually boosted by Bootstrap 4 and Flexbox.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section section-clientserver">
      <div class="container">
        <h2 class="title title-main">Technology Stack</h2>
        <div class="row">
          <div class="col-lg-6 text-center col-server">
            <h4 class="title title-center">./server.js</h4>
            <ul>
              <li>
                <strong>Backbone</strong> Node.js, Express, Hapi.js</li>
              <li>
                <strong>Database</strong> MongoDB, MySQL, Redis</li>
              <li>
                <strong>PHP</strong> Drupal, Zend Framework, Wordpress</li>
              <li>
                <strong>Hardware</strong> RaspberryPi (GSM, Automation, Microservices)</li>
            </ul>
          </div>
          <div class="col-lg-6 text-center col-client">
            <h4 class="title title-center">./client.js</h4>
            <ul>
              <li>
                <strong>Backbone</strong> HTML5, CSS3, Webpack, Grunt/Gulp
              </li>
              <li>
                <strong>Frameworks</strong> Vue.js, Angular 2+, Angular.js, React, jQuery</li>
              <li>
                <strong>Go-To Tools</strong> Bootstrap 4, Font Awesome
              </li>
              <li>
                <strong>SEO</strong> Analysis, Optimization, SPA SEO</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="section section-clients">
      <div class="container">
        <h2 class="title">Clients</h2>
        <div class="container px-0">
          <div class="row no-gutters">
            <div class="col-6 col-md-3 col-client">
              <a href="https://zrzutka.pl/" target="_blank" class="zrzutka">
                <img src="https://zrzutka.pl/assets/imgs/zrzutka-logo.png" class="invert" width="150" alt="">
              </a>
            </div>
            <div class="col-6 col-md-3 text-center col-client">
              <a href="https://www.manhattanministorage.com" target="_blank" class="mms">
                <img src="https://www.manhattanministorage.com/assets/Images/logos/logo-mms.svg" class="invert" alt="" width="150">
              </a>
            </div>
            <div class="col-6 col-md-3 col-client">
              <a href="https://www.parkfast.com" target="_blank" class="pf">
                <img src="https://pfapp.sekvoia.co/img/logo@3x.c09f9cdf.png" class="grayscale" alt="" width="70">
              </a>
            </div>
            <div class="col-6 col-md-3 col-client">
              <a href="https://www.hingeto.com" target="_blank" class="hingeto">
                <img src="https://www.hingeto.com/assets/images/logo.png" class="invert" alt="" width="42">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="section-cta">
      <h5>Have an idea? Let’s do something great together!</h5>
      <a href="mailto:contact@sekvoia.co" class="btn btn-outline-light">Send message</a>
    </section>

  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue';

export default {
  name: 'home',
  components: {
    HelloWorld,
  },
  data: function() {
    return {
      h1s: [
        'Web of Things',
        'Bring Ideas To Life',
        'Power of JavaScript',
        'Web Done Right',
      ],
      h1target: 0,
    };
  },
  mounted() {
    this.h1target = Math.floor(Math.random() * this.h1s.length);
  },
};
</script>
<style lang="scss">
.brand-hero {
  background: url(/bg-hero.png);
  background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  .brand-hero-content {
    text-align: center;
    padding: 9rem 5rem;
    h1 {
      font-size: 90px;
      margin-bottom: 1rem;
      margin-left: -7px;
    }
    hr.short {
      background: #fff;
      height: 2px;
      width: 120px;
      margin-left: 0;
      margin: 1rem auto;
    }
    p {
      font-family: 'Lato', sans-serif;
      font-size: 22px;
      font-weight: 300;
      margin-bottom: 1.5rem;
    }
  }
}

.section {
  padding: 120px 0;
}

.section-image {
  img {
    max-width: 100%;
    width: 100%;
  }
  .title {
    margin-bottom: 1rem;
  }
  p {
    font-weight: 300;
  }
  ul {
    margin-bottom: 2rem;
    li {
      margin-bottom: 1rem;
    }
  }
  &:not(.section-image-reverse) {
    .col-first {
      padding-right: 0;
    }
    .col-last {
      padding-left: 0;
    }
  }
  &.section-image-reverse {
    .col-first {
      padding-right: 0;
    }
    .col-last {
      padding-left: 0;
    }
  }
}

section.section-cta {
  padding: 80px 1rem;
  text-align: center;
  h5 {
    display: inline-block;
    margin-right: 1.5rem;
  }
}

.service {
  margin-bottom: 5rem;
  .icon {
    color: #fff;
    margin-bottom: 1rem;
    height: 32px;
  }
  h5 {
    margin: 0;
  }
  p {
    padding-top: 0.75rem;
    line-height: 1.5;
    padding-right: 3rem;
  }
}

.section.section-clientserver {
  background: #0c0c0c;
  padding: 120px 0;
  margin-bottom: 4rem;
  .title-main {
    margin-bottom: 4rem;
  }
  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
    li {
      strong {
        display: block;
        text-transform: uppercase;
      }
      &:not(strong) {
        font-weight: 300;
      }
      margin-bottom: 0.75rem;
    }
  }
}

.section.section-clients {
  .col-client {
    min-height: 120px;
  }
  a {
    display: block;
    align-items: center;
    justify-content: center;
    display: flex;
    width: 100%;
    height: 100%;
    transition: 0.3s ease-out;
    &.zrzutka:hover {
      background: red;
    }
    &.mms:hover {
      background: #fff;
    }
    &.hingeto:hover {
      background: #FFF;
    }

    &.pf:hover {
      background: #FFF;
    }
    &.zrzutka:hover {
      background: #FFF;
    }

    img {
      transition: 0.25s ease-out;
    }


    &.fx-invert {
      img {
        filter: brightness(0) invert(1);
      }
    }

    &:hover {
      img {
        filter: none !important;
      }
    }
  }
  img {
    
  }
  img.invert {
    filter: brightness(0) invert(1);
  }
  img.grayscale {
    filter: grayscale(100);
  }
  img:hover:not(.invert-force) {
    filter: none !important;
  }
}

@media screen and (max-width: 768px) {
  .section {
    // padding-top: 80px;
  }
  .service p {
    // padding-right: 1rem;
    // text-align: justify;
  }
  .brand-hero {
    background-position: center;

    .brand-hero-content {
      padding: 4.5rem 2.5rem;
      h1 {
        font-size: 60px;
        margin-bottom: 1rem;
      }
      hr.short {
      }
      p {
        width: 100%;
        max-width: 100%;
      }
    }
  }
  .section .title {
    margin-bottom: 2rem;
  }

  .section-image {
    .col-first,
    .col-last {
      padding: 0 15px !important;
    }
    .col-content {
      padding-top: 4rem;
      padding-bottom: 4rem;
    }
  }
}

@media screen and (max-width: 576px) {
  .section {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .col-server {
    margin-bottom: 4rem;
  }
  .col-client {
    margin-bottom: 2rem;
  }
  section.section-cta h5 {
    margin-right: auto;
  }
}
</style>
